<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Three-Year Graduation Rate"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('three_year_grad')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Three Year
      Graduation Rate (External) Tool.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support (External)
          <i class="fa-solid fa-arrow-right"></i> Three Year Graduation Rate
        </h1>

        <h3 class="h3-second-header">
          Initial results with default form values
        </h3>

        <ul class="unordered-list">
          <li>
            Once you get to the page, results will automatically generate based
            on the default values in the Three Year Graduation Rate form fields.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">
          Goal for Three Year Graduation Rate tool
        </h3>

        <ul class="unordered-list">
          <li>
            Analyze on-time graphs by completion AA degree, first fall GPA and
            prerequisite completion rate.
          </li>
          <li>To predict on-time graduation among transfer students.</li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">
          Three Year Graduation Rate Form Submission
        </h3>

        <ol class="ordered-list">
          <li>Select outcome variable [Default: On-Time]</li>
          <li>Select predict model [Default: Admit On-Time]</li>
          <li>Select methods [Default: On-Time Predict]</li>
        </ol>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageThreeYearGraduationRate55']"
            alt=""
          />
          <p class="picture-caption">
            Figure 55: Default inputs for Three Year Graduation Rate form
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">
          Additional information about predictors and predictive models
        </h3>

        <!-- <ol class="ordered-list">
          <li>Select a cohort [Default: 2020]</li>
          <li>Select the range for high school GPA [Default: 0 - 5.04]</li>
          <li>Select a demographic [Default: None]</li>
        </ol> -->
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="smaller-pics"
            [(src)]="env['logo_paths']['helpPageThreeYearGraduationRate56']"
            alt=""
          />
          <p class="picture-caption">
            Figure 56: Predictors and Predictive Models
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After you change the form fields’ values to your desired values, the
            form will automatically submit itself.
          </li>
          <li>
            The results will be regenerated based on the new input values.
          </li>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageThreeYearGraduationRate57']"
              alt=""
            />
            <p class="picture-caption">
              Figure 57: Three Year Graduation Rate Table Result
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageThreeYearGraduationRate58']"
              alt=""
            />
            <p class="picture-caption">
              Figure 58: Three Year Graduation Rate First and Second Graphs
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageThreeYearGraduationRate58a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 58a: Three Year Graduation Rate Second and Third Graph
              Result
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getExternalAdminSupportRelatedLinkBasedOnTool(
        'Three-Year Graduation Rate',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
